/** A staff member's own profile card. Enum values are wire values - see CLAUDE.md. */
export const PRONOUN_OPTIONS = [
  { value: 'he/him', label: 'He/Him' },
  { value: 'she/her', label: 'She/Her' },
  { value: 'they/them', label: 'They/Them' },
  { value: 'he/they', label: 'He/They' },
  { value: 'she/they', label: 'She/They' },
  { value: 'any', label: 'Any pronouns' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
];

export const SPECIALISM_OPTIONS = [
  { value: 'insomnia', label: 'Insomnia' },
  { value: 'sleep_quality', label: 'Sleep quality' },
  { value: 'sleep_apnea', label: 'Sleep apnea' },
  { value: 'circadian_rhythm', label: 'Circadian rhythm' },
  { value: 'shift_work', label: 'Shift work' },
  { value: 'jet_lag', label: 'Jet lag' },
  { value: 'stress_and_anxiety', label: 'Stress and anxiety' },
  { value: 'sleep_hygiene', label: 'Sleep hygiene' },
  { value: 'nightmares', label: 'Nightmares' },
  { value: 'snoring', label: 'Snoring' },
];

export const BIO_MAX = 2000;
export const SPECIALISMS_MAX = 10;
export const YEARS_MIN = 0;
export const YEARS_MAX = 50;

const SPECIALISM_LABELS = SPECIALISM_OPTIONS.reduce(
  (all, option) => ({ ...all, [option.value]: option.label }),
  {}
);

const PRONOUN_LABELS = PRONOUN_OPTIONS.reduce(
  (all, option) => ({ ...all, [option.value]: option.label }),
  {}
);

// An unrecognised value still renders, so a newly added enum stays visible.
export const specialismLabel = (value) => SPECIALISM_LABELS[value] || value;
export const pronounLabel = (value) => PRONOUN_LABELS[value] || value;

// PUT is a full replace, so build the complete object from the loaded card.
export const toProfilePayload = (form) => ({
  pronouns: form?.pronouns || '',
  bio: form?.bio || '',
  years_experience: Number(form?.years_experience) || 0,
  specialisms: [...new Set(form?.specialisms || [])].slice(0, SPECIALISMS_MAX),
});

const firstMessage = (value) => {
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return firstMessage(value[0]);
  if (value && typeof value === 'object') return firstMessage(Object.values(value)[0]);
  return null;
};

// A 400 nests by field and sometimes list index, so surface the first leaf string.
export const profileFieldErrors = (error) => {
  const details = error?.response?.data?.error?.details;
  if (!details || typeof details !== 'object') return {};
  return Object.entries(details).reduce((all, [field, value]) => {
    const message = firstMessage(value);
    return message ? { ...all, [field]: message } : all;
  }, {});
};

// 403 here carries DRF's default body with no error code, so it is routed on status.
export const isProfileForbidden = (error) => error?.response?.status === 403;
